import { gql } from "@apollo/client";

export const GET_ADDRESS_LOCATION_TYPE_DICT_CONFIG = gql`
    query GetAddressLocationTypeDictConfig {
        getAddressLocationTypeDictConfig {
            primaryCode
            primaryNameZh
            primaryNameEn
            primaryNameEs
            secondaryCode
            secondaryNameZh
            dropdownNameZh
            dropdownNameEn
            dropdownNameEs
            sortOrder
        }
    }
`;

export interface AddressLocationTypeDictItem {
    primaryCode: string;
    primaryNameZh: string;
    primaryNameEn: string;
    primaryNameEs: string;
    secondaryCode: string;
    /** 二级分类名（仅中文，desktop-web 用） */
    secondaryNameZh: string;
    /** 司机端下拉文案（mobile-web Picker 用） */
    dropdownNameZh: string;
    dropdownNameEn: string;
    dropdownNameEs: string;
    sortOrder: number;
}

export interface GetAddressLocationTypeDictConfigResponse {
    getAddressLocationTypeDictConfig: AddressLocationTypeDictItem[];
}
